// Segmented table/tiles switch shared by master-data list pages. Height matches
// .finput/.btn-toolbar exactly (see .view-toggle in index.css) so it sits flush
// with the rest of the filter toolbar.
export default function ViewToggle({ view, onChange }) {
  return (
    <div className="view-toggle" data-active={view} role="tablist" aria-label="Layout">
      <div className="view-toggle-thumb" aria-hidden="true" />
      <button
        type="button"
        role="tab"
        aria-selected={view === 'table'}
        className={`view-toggle-btn ${view === 'table' ? 'active' : ''}`}
        onClick={() => onChange('table')}
      >
        <i className="fa-solid fa-table" /><span>Table</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={view === 'tiles'}
        className={`view-toggle-btn ${view === 'tiles' ? 'active' : ''}`}
        onClick={() => onChange('tiles')}
      >
        <i className="fa-solid fa-table-cells-large" /><span>Tiles</span>
      </button>
    </div>
  );
}
